import React from 'react';
import MainLayout from '../../layout/MainLayout';
import Experience from './Experience';
import Project from './Project';

const Work = () => {
    return (
        <MainLayout>
            <Experience />
            <Project />
        </MainLayout>
    );
};

export default Work;